import React from "react";
import ViewPhotoSamplePopup from "./ViewPhotoSamplePopup";

export interface IViewPhotoSampleMobileViewProps {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
}

// Mobile uses the same centred modal (single column, internal scroll) as
// desktop instead of a bottom sheet.
const ViewPhotoSampleMobileViewProps = (props: IViewPhotoSampleMobileViewProps) => (
  <ViewPhotoSamplePopup showPopup={props.showPopup} setShowPopup={props.setShowPopup} />
);
export default ViewPhotoSampleMobileViewProps;
